import { render, staticRenderFns } from "./loginRoutes.vue?vue&type=template&id=56b30245&"
import script from "./loginRoutes.vue?vue&type=script&lang=js&"
export * from "./loginRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b30245')) {
      api.createRecord('56b30245', component.options)
    } else {
      api.reload('56b30245', component.options)
    }
    module.hot.accept("./loginRoutes.vue?vue&type=template&id=56b30245&", function () {
      api.rerender('56b30245', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/loginRoutes.vue"
export default component.exports